// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3_JzH","label":"LabeledBox_label__2RY48"};